import { UploadSplitter } from "features/uploads";

export function SplitUploadPage({ match }) {
  const { uploadId } = match.params;

  return <UploadSplitter uploadId={uploadId} />;
}
